import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../Components/MainScreen";

const BaseRouter = () => (
  <Switch>
    <Route exact path="/">
      <Home />
    </Route>
  </Switch>
);
export default BaseRouter;
